import {AssessmentItemsVI} from "./assessment-items/vi";
import {AssessmentTemplateVI} from "./assessment-template/vi";

export const CompetencyAssessmentVI = {
    "assessment": {
        headingLabel: "Đánh giá nhân sự",
        breadcrumb: "Danh sách phiếu đánh giá nhân sự",
        heading: {
            "competencyAssessmentList": "Danh sách các tiêu chí đánh giá",
            "add": "Tạo mới phiếu đánh giá",
            update: "Cập nhật phiếu đánh giá",
            "assessmentEvaluators": "Người đánh giá",
            "generalInformation": "Thông tin chung",
            "employeeList": "Danh sách nhân sự",
            assessmentEmployeeDetail: "Kết quả đánh giá",
            "assessmentEmployee": "Phiếu đánh giá",
            score: "Chi tiết chấm điểm nhân sự"
        },
        sider: {
            "listAssessmentItem": "Tiêu chí đánh giá",
            "listAssessmentTemplate": "Mẫu đánh giá",
            "listAssessment": "Phiếu đánh giá"
        },
        label: {
            "criteria": {
                "name": "Tiêu chí đánh giá",
                "point": "Điểm yêu cầu",
                "proportion": "Tỷ trọng",
                "isEqual": "Tỉ trọng đều"
            },
            total: "Kết quả",
            status: "Trạng thái",
            "employee": "Nhân sự",
            code: "Mã nhân sự",
            "assessmentEmployee": {
                "name": "Phiếu đánh giá",
                "status": "Trạng thái",
                "criteriaAmount": "Số tiêu chí",
                "employeeAmount": "Số nhân sự",
                "template": "Mẫu đánh giá",
                "isTemplate": "Chọn từ mẫu đánh giá",
                "type": "Loại đánh giá",
                "periodType": "Kỳ đánh giá",
                "month": "Tháng",
                "year": "Năm",
                "crop": "Vụ",
                "quarter": "Mùa",
                "startDate": "Ngày bắt đầu",
                "endDate": "Ngày kết thúc",
                "deadline": "Hạn đánh giá",
                "supervisor": "Người theo dõi",
                "managers": "Người quản lý",
                "isSequential": "Đánh giá tuần tự",
                "createDate": "Ngày tạo",
                "department": "Phòng ban",
                position: "Vị trí",
                workingDate: "Ngày vào",
                order: "Thứ tự",
                pointStatus: "Trạng thái chấm điểm"
            },
            "assessmentEvaluator": {
                "evaluator": "Người chấm",
                "type": "Hội đồng đánh giá"
            },
            assessmentEmployeeDetail: {
                "name": "Tiêu chí",
                proportion: "Tỉ trọng (%)",
                benchmark: "Điểm chuẩn"
            }
        },
        value: {
            quarter: {
                one: "Quý 1",
                two: "Quý 2",
                three: "Quý 3",
                four: "Quý 4",
            },
            crop: {
                first: "6 tháng đầu năm",
                last: "6 tháng cuối năm",
            },
            "point": {
                "0": "Điểm yêu cầu 1",
                "1": "Điểm yêu cầu 2",
                "2": "Điểm yêu cầu 3",
                "3": "Điểm yêu cầu 4",
                "4": "Điểm yêu cầu 5"
            },
            "isEqual": {
                "yes": "Có",
                "no": "Không"
            },
            sequential: {
                yes: "Tuần tự",
                no: "Song song"
            },
            "status": {
                "pending": "Đang đánh giá",
                "approved": "Hoàn thành",
                "trashed": "Hủy",
                "waiting": "Chờ đánh giá",
                "expired": "Hết hạn",
                "pass": "Qua",
                "notPass": "Không qua"
            },
            "type": {
                "transfer": "Đánh giá chuyển hợp đồng",
                "periodic": "Đánh giá định kỳ"
            },
            "periodType": {
                "month": "Tháng",
                "year": "Năm",
                "quarter": "Mùa",
                "crop": "Vụ",
                "random": "Ngẫu nhiên"
            },
            "month": {
                "1": "Tháng 1",
                "2": "Tháng 2",
                "3": "Tháng 3",
                "4": "Tháng 4",
                "5": "Tháng 5",
                "6": "Tháng 6",
                "7": "Tháng 7",
                "8": "Tháng 8",
                "9": "Tháng 9",
                "10": "Tháng 10",
                "11": "Tháng 11",
                "12": "Tháng 12"
            },
            assessmentEvaluator: {
                "type": {
                    "personel": "Cá nhân đánh giá",
                    "directorate": "HCNS đánh giá",
                    "partner": "Đồng nghiệp đánh giá",
                    "manager": "Quản lý trực tiếp đánh giá",
                    "admainistrative": "Hội đồng đánh giá"
                }
            }
        },
        "placeholder": {
            "name": "Nhập Tiêu chí đánh giá",
            "point": "Nhập Điểm yêu cầu",
            "proportion": "Nhập Tỷ trọng"
        },
        "action": {
            "status": "Cập nhật trạng thái",
            "detail": "Xem chi tiết",
            "point": "Chấm điểm"
        },
        "required": {
            assessmentEmployeeDetail: "Yêu cầu có ít nhất 1 nhân sự",
            month: "Yêu cầu nhập tháng",
            year: "Yêu cầu nhập năm",
            crop: "Yêu cầu nhập vụ",
            quarter: "Yêu cầu nhập mùa",
            startDate: "Yêu cầu nhập ngày bắt đầu",
            endDate: "Yêu cầu nhập ngày kết thúc",
            deadline: "Yêu cầu nhập hạn đánh giá",
            personnel: "Yêu cầu nhập nhân sự",
            point: "Yêu cầu nhập điểm",
            assessmentEmployee: {
                name: "Yêu cầu nhập tên",
                type: "Yêu cầu nhập loại đánh giá",
                template: "Yêu cầu nhập mẫu đánh giá",
                supervisor: "Yêu cầu nhập người theo dõi",
                manager: "Yêu cầu nhập người quản lý"
            },
            assessmentEvaluator: {
                type: "Yêu cầu nhập hội đồng đánh giá",
                evaluator: "Yêu cầu nhập người chấm",
                main: "Yêu cầu nhập ít nhất một hội đồng đánh giá"
            }
        },
        "message": {
            "status": "Cập nhật trạng thái thành công",
            criteria: {
                "required": {
                    "name": "Yêu cầu nhập tên",
                    "point": "Yêu cầu nhập loại điểm",
                    "proportion": "Yêu cầu nhập tỷ trọng",
                    main: "Yêu cầu nhập ít nhất một tiêu chí đồng đánh giá"
                }
            },
            error: "Vui lòng nhập đầy đủ thông tin ở các tab"
        }
    },
    ...AssessmentItemsVI,
    ...AssessmentTemplateVI
}